"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@aws-amplify/core");
var BaseProvider_1 = require("./BaseProvider");
var logger = new core_1.ConsoleLogger('AmazonProvider');
var AmazonProvider = /** @class */ (function (_super) {
    __extends(AmazonProvider, _super);
    function AmazonProvider(options) {
        var _this = _super.call(this, options) || this;
        _this._credentialsDomain = AmazonProvider.DEFAULT_DOMAIN;
        _this._credentialsTokenSource = BaseProvider_1.default.ACCESS_TOKEN;
        return _this;
    }
    AmazonProvider.prototype.configure = function (options) {
        _super.prototype.configure.call(this, options);
        var _a = this._config.refreshHandlers, refreshHandlers = _a === void 0 ? {} : _a;
        this._refreshHandler =
            this._refreshHandler ||
                refreshHandlers['amazon'];
    };
    AmazonProvider.prototype.getProviderName = function () {
        return AmazonProvider.NAME;
    };
    AmazonProvider.NAME = 'Amazon';
    AmazonProvider.DEFAULT_DOMAIN = 'www.amazon.com';
    return AmazonProvider;
}(BaseProvider_1.default));
exports.default = AmazonProvider;
//# sourceMappingURL=AmazonProvider.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@aws-amplify/auth/lib/providers/AmazonProvider.js
// module id = 1171
// module chunks = 19